import { Component, EventEmitter, Input, Output, ElementRef, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'kt-form-popup',
  templateUrl: './form-popup.component.html',
  styleUrls: ['./form-popup.component.scss']
})
export class FormPopupComponent implements AfterViewInit, OnDestroy {
  @Input() title: string = '';
  @Input() showCloseIcon: boolean = true;
  @Input() hasFooter: boolean = true;

  @Output() close = new EventEmitter<void>();

  @ViewChild('footerWrapper') footerWrapper: ElementRef<HTMLElement>;

  showFooterContent = true;
  private observer: MutationObserver;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.checkFooter();
    if (this.footerWrapper) {
      this.observer = new MutationObserver(() => this.checkFooter());
      this.observer.observe(this.footerWrapper.nativeElement, { childList: true, subtree: true });
    }
  }

  checkFooter() {
    if (this.footerWrapper) {
      const hasContent = this.footerWrapper.nativeElement.children.length > 0;
      if (this.showFooterContent !== hasContent) {
        this.showFooterContent = hasContent;
        this.cdr.detectChanges();
      }
    }
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

